export const INVOICE_PAYMENT_STATUSES = { PAID: 'paid' };
export const INVOICE_STATUSES = {
  VOIDED: 'VOIDED',
  COMMITTED: 'COMMITTED',
  OPENED: 'OPENED',
  REGENERATED: 'REGENERATED'
};
